import { motion } from "motion/react";
import styled from "styled-components";

export const ModalBackdrop = styled(motion.div)`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: start;
    justify-content: center;
    background: rgba(0, 0, 0, 0.8);
    z-index: 100;
    overflow-y: auto;
    padding: 2rem 0;
    backdrop-filter: blur(1px);
`;
